import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RoleState, initPermissions, initRoles, initApplications } from './RoleReducer';

export const selectRoleState = createFeatureSelector<RoleState>('role');

export const initRoleSelector = createSelector(
  selectRoleState,
  initRoles
);

export const initPermissionSelector = createSelector(
  selectRoleState,
  initPermissions
);

export const initApplicationSelector = createSelector(
  selectRoleState,
  initApplications
);
